import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import auth from '@websanova/vue-auth'
import httpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm'
import routerVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js'
import moment from 'moment'
import { extend, setInteractionMode, ValidationObserver, ValidationProvider } from 'vee-validate'
import { alpha, confirmed, email, max, min, required } from 'vee-validate/dist/rules'
import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import socketIo from 'socket.io-client'
import VueEcho from 'vue-echo'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.scss'
import Notifications from 'vue-notification'
import Pusher from 'pusher-js';

import { axiosChatApi } from '@/store/chat'
import {
  APP_API_URL,
  PUSHER_APP_CLUSTER,
  PUSHER_APP_KEY,
  PUSHER_PORT,
  PUSHER_PUBLIC_HOST,
  PUSHER_PUBLIC_PORT, SOCKET_HOST,
} from '../const/api'

export function initPlugins(store) {
  initAxios()
  initAuth(store)
  initMoment()
  initValidate()
  axiosChatApi()
  initSwiper()
  initSelect()
  initToast()
  initViewer()
  initSocket(store)
}

export function initAxios() {
  axios.defaults.withCredentials = true
  axios.interceptors.response.use(
    (response) => {
      if (response.data?.data) {
        response.data = response.data.data
      }
      return response
    },
    (error) => {
      return Promise.reject(error)
    },
  )
  axios.defaults.baseURL = APP_API_URL
  Vue.use(VueAxios, axios)
}

const authHttp = (store) => ({
    request: function(req, token) {
      let timeZone;
      try {
        timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      catch (error) {
        console.error(error);
      }

      this.http.setHeaders.call(this, req, {
        Authorization: `Bearer ${token}`,
        'x-lang': localStorage.getItem('lang'),
        'Time-Zone': timeZone,
      })

    },
    response: function(res) {
      return res.data.token
    },
  }
)
export function initAuth(store) {
  Vue.use(auth, {
    auth: authHttp(store),
    http: httpAxios,
    router: routerVueRouter,
    authRedirect: { name: 'Auth' },
    refreshData: {
      url: '../sanctum/csrf-cookie',
      enabled: false,
    },
    loginData: {
      url: '/login',
      redirect: { name: 'Dashboard' },
    },
    registerData: {
      url: '/register',
      redirect: { name: 'Auth' },
    },
    fetchData: {
      url: '/profile',
      enabled: true,
    },
    logoutData: {
      url: '/logout',
      makeRequest: true,
      redirect: { name: 'Auth' },
    },
    parseUserData: (data) => {
      data.roles = data.role?.alias //Для $auth.check()
      return data
    },
  })
}

export function initMoment() {
  moment.updateLocale('en', {
    relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: 'a few sec',
      ss: '%d sec',
      m: '1 min',
      mm: '%d min',
      h: '1 hour',
      hh: '%d hours',
    },
  })
}

export function initSwiper() {
  Vue.use(VueAwesomeSwiper)
}

export function initSelect() {
  Vue.component('v-select', vSelect)
}

export function initToast() {
  Vue.use(Notifications, { name: 'toast' })
}

export function initValidate() {
  extend('required', { ...required, message: 'This field cant be blank' })
  extend('email', { ...email, message: 'Worng email format' })
  extend('alpha', { ...alpha, message: 'Should be only letters' })
  extend('confirmed', { ...confirmed, message: 'Password doesnt match' })
  extend('min', { ...min, message: 'Min {length} symbols' })
  extend('max', { ...max, message: 'Max {length} symbols' })

  extend('tel', {
    validate: (value) => {
      // eslint-disable-next-line no-useless-escape
      const reg = /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/
      return value.match(reg)
    },
    message: 'Введите номер телефона',
  })

  Vue.component('ValidationProvider', ValidationProvider)
  Vue.component('ValidationObserver', ValidationObserver)

  setInteractionMode('passive')
}

export function initViewer() {
  Vue.use(VueViewer)
}

export function initSocket(store) {
  const token = localStorage.getItem('auth_token_default')

   Vue.use(VueEcho, {
     broadcaster: 'socket.io',
     client: socketIo,
     host: `https://${SOCKET_HOST}:443`,
     auth: {
       // host: 'https://appdev.greentech-ahk-za.kz/',
       // endpoint: '/broadcasting/auth',
       headers: {
         Authorization: 'Bearer ' + token,
         // "X-CSRF-TOKEN": window.csrf_token
       },
     },
   })
}
/*
Vue.use(VueEcho, {
  broadcaster: 'pusher',
  client: Pusher,

  key: PUSHER_APP_KEY,
  host: PUSHER_PUBLIC_HOST,
  namespace: PUSHER_APP_CLUSTER,

  cluster: PUSHER_APP_CLUSTER,
  httpHost: PUSHER_PUBLIC_HOST,
  httpPort: PUSHER_PORT,
  httpsPort: PUSHER_PORT,
  wsHost: PUSHER_PUBLIC_HOST,
  wsPort: PUSHER_PUBLIC_PORT,
  wssPort: PUSHER_PORT,
  forceTLS: false,
  enabledTransports: ['ws', 'wss'],
  auth: {
    headers: {
      Authorization: 'Bearer ' + token,
      // "X-CSRF-TOKEN": window.csrf_token
    },
  },
})*/
